<tds-header>
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>

  <tds-header-title>KRAS</tds-header-title>
  
  <tds-header-dropdown slot="end" class="profile" no-dropdown-icon>
    <tds-icon slot="icon" name="profile" size="24px"></tds-icon> 

    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user
        header="Name Nameson"
        subheader="Company name"
      ></tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item selected>
        <a href="https://www.scania.com">My Instructions</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a href="https://www.scania.com">Task List</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>


</tds-header>
